import { useCallback, useRef, useState } from 'react';

export async function saveOfferDocuments(options: {
  proposal?: () => Promise<string | void>;
  quotation?: () => Promise<boolean | void>;
  linkProposalId: { current: string };
}): Promise<boolean> {
  if (options.proposal) {
    const id = await options.proposal();
    if (!id) return false;
    options.linkProposalId.current = id;
  }
  if (!options.quotation) return true;
  const quoteOk = await options.quotation();
  return quoteOk !== false;
}

export function useOfferSaves() {
  const proposalSave = useRef<() => Promise<string | void>>(async () => undefined);
  const quotationSave = useRef<() => Promise<boolean | void>>(async () => undefined);
  const proposalOn = useRef(false);
  const quotationOn = useRef(false);
  const linkProposalId = useRef('');
  const [dirty, setDirty] = useState({ proposal: false, quotation: false });
  const onProposalDirty = useCallback((value: boolean) => {
    setDirty((current) => current.proposal === value ? current : { ...current, proposal: value });
  }, []);
  const onQuotationDirty = useCallback((value: boolean) => {
    setDirty((current) => current.quotation === value ? current : { ...current, quotation: value });
  }, []);
  const registerProposal = useCallback((fn: () => Promise<string | void>) => {
    proposalSave.current = fn;
    proposalOn.current = true;
  }, []);
  const registerQuotation = useCallback((fn: () => Promise<boolean | void>) => {
    quotationSave.current = fn;
    quotationOn.current = true;
  }, []);
  const saveAll = useCallback(async () => saveOfferDocuments({
    proposal: proposalOn.current ? () => proposalSave.current() : undefined,
    quotation: quotationOn.current ? () => quotationSave.current() : undefined,
    linkProposalId,
  }), []);
  return { registerProposal, registerQuotation, linkProposalId, dirty, onProposalDirty, onQuotationDirty, saveAll };
}
